import { iCallCampaignState } from "./CallCampaign";
import { defaultCallCampaignState } from "./CallCampaign/defaultState";
import { ICallReportState, ICallReportValueState } from "./CallReport";
import { defaultCallReportListState, defaultCallReportValueState } from "./CallReport/defaultState";
import { ICommon, initialCommonState } from "./common/types";
import { IComplaintsState, initialComplaintsState } from "./complaints/types";
import { ICustomizerState } from "./customizer/customizerReducer";
import { IDashbaord, initialDashboard } from "./dashboard/types";
import { IGoogleNearBy, IGoogleNearByState, IMechanicState, defaultGoogleNearByState, defaultMechanicState } from "./mechanics";
import { IMessagesState } from "./messages/messages.types";
import { initialMessagesState } from "./messages/messagesState";
import {
  initialOnlineDashboard,
  IOnlineDashbaord,
} from "./onlineDashboard/types";
import { IOnlineDsaLimitState } from "./OnlineDsaLimit/OnlineDsaLimit.types";
import { OnlineDsaLimitInitialState } from "./OnlineDsaLimit/OnlineDsaLimit.state";
import { IOrderDetailsState } from "./OrderDetails";
import { defaultOrderDetailsState } from "./OrderDetails/defaultState";
import { IProductState } from "./Product";
import { defaultProductState } from "./Product/defaultState";
import { initialPromoState, IPromoState } from "./PromoCode/types";
import {
  initialRegisteredUsersState,
  IRegisteredUsers,
} from "./registeredUsers/types";
import { initialSowDashboard, ISowDashbaord } from "./sowDashboard/types";
import { initialServicesState, IServiceState } from "./sowService/types";
import { ILeadsDataState } from "./leadsData";
import { LeadsDataInitialState } from "./leadsData/leadsData.state";
import { IBankfund24DataState } from "./Bankfund24/bankfund24.types";
import { Bankfund24DataInitialState } from "./Bankfund24/bankfund24.state";
import { IAgentDashboardInformationState } from "./agentdashboard/agentDashboard.types";
import { defaultAgentDashbaordInfoState } from "./agentdashboard/agentDashboard.state";
import { DndNumberDataInitialState, IDndNumberDataState } from "./DndNumber";

export interface IDropdownListType {
  key: string;
  text: string;
  value: string;
}

export interface IStoreState {
  customizerReducer: ICustomizerState;
  common: ICommon;
  registeredUsers: IRegisteredUsers;
  dashboard: IDashbaord;
  sowDashboard: ISowDashbaord;
  complaints: IComplaintsState;
  promo: IPromoState;
  services: IServiceState;
  onlineDsa: IOnlineDashbaord;
  product: IProductState;
  mechanics: IMechanicState;
  message: IMessagesState;
  googleNearBy: IGoogleNearByState;
  callCampaign: iCallCampaignState;

  callReport: ICallReportState;
  callReportValue: ICallReportValueState;
  orderDetails: IOrderDetailsState
  onlineDsaLimit: IOnlineDsaLimitState;
  leadsData: ILeadsDataState;
  bankfund24: IBankfund24DataState;
  agentDashboard: IAgentDashboardInformationState;
  dndNumber: IDndNumberDataState;
}

export const initialStoreState: IStoreState = {
  customizerReducer: {
    activeDir: "ltr",
    activeNavbarBg: "#0b70fb", // This can be any color,
    activeSidebarBg: "#ffffff", // This can be any color
    activeMode: "light", // This ca n be light or dark
    activeTheme: "LIGHT_BLUE_THEME", // BLUE_THEME, GREEN_THEME, RED_THEME, BLACK_THEME, PURPLE_THEME, INDIGO_THEME
    SidebarWidth: 240,
  },
  common: initialCommonState,
  mechanics: defaultMechanicState,
  message: initialMessagesState,
  googleNearBy: defaultGoogleNearByState,
  registeredUsers: initialRegisteredUsersState,
  dashboard: initialDashboard,
  complaints: initialComplaintsState,
  promo: initialPromoState,
  services: initialServicesState,
  sowDashboard: initialSowDashboard,
  onlineDsa: initialOnlineDashboard,
  product: defaultProductState,
  callReport: defaultCallReportListState,
  callReportValue: defaultCallReportValueState,
  orderDetails: defaultOrderDetailsState,
  callCampaign: defaultCallCampaignState,
  onlineDsaLimit: OnlineDsaLimitInitialState,
  leadsData: LeadsDataInitialState,
  bankfund24: Bankfund24DataInitialState,
  agentDashboard: defaultAgentDashbaordInfoState,
  dndNumber: DndNumberDataInitialState,
};
